<div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
        <div class="table-responsive" *ngIf="listaProtestos">

  

                <div *ngIf="listaProtestos?.length === 0" #alert class="alert alert-info alert-dismissible fade show m-0" role="alert">
                    <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <strong>No existen registros!</strong> para los filtros seleccionados.
                </div>

            <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaProtestos?.length > 0">
                <thead class="grey lighten-2">
                    <tr>
                        <!-- <th scope="col">Código</th> -->
                        <th scope="col">Rut Cliente</th>
                        <th scope="col">Nombre Cliente</th>
                        <th scope="col">Fecha Protesto</th>
                        <th scope="col">Cheque</th>
                        <th scope="col">Banco</th>
                        <th scope="col" class="text-right">Monto</th>
                        <th scope="col">Fec. Vcto.</th>
                        <th scope="col">Usuario</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let protesto of listaProtestos">
                        <!-- <td>{{protesto.codigo}}</td> -->
                        <td>{{protesto.cliente_proveedor_rutFormato | rut}}</td>
                        <td>{{protesto.cliente_proveedor_nombre}}</td>
                        <td>{{protesto.fecha_protesto | fecha}}</td>
                        <td>{{protesto.numero_doc}}</td>
                        <td>{{protesto.nombre_banco}}</td>
                        <td class="text-right">{{protesto.monto | numerico}}</td>
                        <td>{{protesto.fecha_registro | fecha}}</td>
                        <td>{{protesto.nombre_usuario}}</td>
                        <td>
                            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                                (click)="loadModalProtesto(protesto.codigo)" mdbTooltip="Ver" placement="right">
                                <mdb-icon fas icon="eye"></mdb-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
                <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                    *ngIf="listaProtestos?.length > 0"></app-pagination>
            </table>
        </div>
    </div>
</div>

<div class="card mb-2 wow" *ngIf="listaProtestos?.length > 0">
    <div class="card-body d-sm-flex p-1 justify-content-end">
        <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="downloadExcel()">
            Excel
        </button>
        <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm">
            PDF
        </button>
    </div>
</div>

<app-cheques-protesto-modal-add-edit-protesto (onSuccess)="buscar()"></app-cheques-protesto-modal-add-edit-protesto>